import { setMode } from '@stencil/core';

export default function () {
  setMode((elm) => {
    // Try to get mode from the element's property or attribute directly
    let mode = (elm as any).mode || elm.getAttribute('mode');
    if (mode) {
      return mode;
    }

    // Traverse the ancestor elements in the shadow DOM to find a mode
    let ancestor = elm.getRootNode() as ShadowRoot;
    while (ancestor.host) {
      mode = (ancestor.host as any).mode || ancestor.host.getAttribute('mode');
      if (mode) {
        return mode;
      }
      ancestor = ancestor.host.getRootNode() as ShadowRoot;
    }

    // Return default mode if none is found
    return 'default';
  });
}
